import { mdiDotsVertical } from '@mdi/js';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Popover, PopoverDivider, PopoverItem } from '../../base';
import { CardAction } from '../cards/cards';
import * as S from './claim-overview.styles';

const isClickAction = (action: CardAction): action is CardAction & { onClick: () => void | Promise<void> } =>
    'onClick' in action;

const srOnlyTextStyle: React.CSSProperties = {
    position: 'absolute',
    width: '1px',
    height: '1px',
    padding: 0,
    margin: '-1px',
    overflow: 'hidden',
    clip: 'rect(0, 0, 0, 0)',
    whiteSpace: 'nowrap',
    border: 0,
};

export const ClaimOverviewSectionMenu: React.FC<{ actions: CardAction[] }> = ({ actions }) => {
    const navigate = useNavigate();

    const handleAction = (action: CardAction) => async (): Promise<void> => {
        if (isClickAction(action)) {
            await action.onClick();
            return;
        }

        if (action.target === '_self') {
            navigate(action.href);
            return;
        }

        window.open(action.href, '_blank', 'noopener,noreferrer');
    };

    return (
        <Popover
            align="right"
            renderButton={(): React.ReactElement => (
                <S.SectionMenuTrigger type="button" variant="unstyled">
                    <span style={srOnlyTextStyle}>Section actions</span>
                    <S.SectionMenuIcon path={mdiDotsVertical} />
                </S.SectionMenuTrigger>
            )}>
            {actions.flatMap((action, index) => {
                const items = [
                    <PopoverItem key={`${action.label}-${index}`} onClick={handleAction(action)}>
                        {action.label}
                    </PopoverItem>,
                ];

                if (action.divide && index < actions.length - 1) {
                    items.push(<PopoverDivider key={`${action.label}-${index}-divider`} />);
                }

                return items;
            })}
        </Popover>
    );
};
